import React from 'react';

function Component() {
  return <div>Página no encontrada</div>;
}

export default Component;
